import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { ArrowRight } from 'lucide-react';
import Navbar from '../components/Navbar';
import { BLOG_POSTS } from '../data/blogPosts';

export default function BlogIndexPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-zinc-50 text-zinc-950">
      <Helmet>
        <title>Blog — Microtransactions, EA Games, and Gaming Industry Satire | CalcByEA™</title>
        <meta name="description" content="Long-form commentary on EA Games, microtransactions, pay-to-win culture, and the gaming industry's relationship with money. Written in the spirit of the calculator that charges $9.99 for an equals sign." />
        <link rel="canonical" href="https://calculatorbyea.com/blog" />
        <meta property="og:url" content="https://calculatorbyea.com/blog" />
        <meta property="og:title" content="Blog — Microtransactions & Gaming Industry Satire | CalcByEA™" />
        <meta property="og:description" content="Long-form commentary on EA Games, microtransactions, pay-to-win culture, and the gaming industry's relationship with money." />
      </Helmet>

      <Navbar />

      <div className="pt-14 max-w-4xl mx-auto px-6 pb-24">

        {/* Header */}
        <div className="border-b-2 border-zinc-950 pt-16 pb-10 mb-0">
          <div className="text-[9px] font-bold uppercase tracking-[0.35em] text-zinc-400 mb-3">Editorial</div>
          <h1 className="font-bebas text-6xl sm:text-7xl text-zinc-950 leading-none mb-4">The Blog</h1>
          <p className="text-zinc-500 text-base max-w-lg">
            On microtransactions, gaming industry greed, and what it means that a calculator now has a season pass.
          </p>
        </div>

        {/* Posts list */}
        <div>
          {BLOG_POSTS.map((post, i) => (
            <article
              key={post.slug}
              className={`border-b border-zinc-200 py-10 cursor-pointer group ${i === 0 ? 'border-t-0' : ''}`}
              onClick={() => navigate(`/blog/${post.slug}`)}
              data-testid={`blog-post-${post.slug}`}
            >
              <div className="flex flex-col sm:flex-row sm:items-start gap-6">
                <div className="flex-1">
                  <div className="flex items-center gap-3 mb-3">
                    <span className="text-[9px] font-bold uppercase tracking-[0.3em] text-zinc-400 border border-zinc-200 px-2 py-0.5">{post.category}</span>
                    <span className="text-[9px] text-zinc-300 uppercase tracking-widest">{post.date}</span>
                    <span className="text-[9px] text-zinc-300 uppercase tracking-widest">{post.readTime}</span>
                  </div>
                  <h2 className="font-bebas text-3xl sm:text-4xl text-zinc-950 leading-tight mb-3 group-hover:text-zinc-600 transition-colors duration-100">
                    {post.title}
                  </h2>
                  <p className="text-zinc-500 text-sm leading-relaxed max-w-xl">{post.excerpt}</p>
                </div>
                <div className="shrink-0 flex items-center sm:items-end sm:pb-1">
                  <span className="flex items-center gap-2 text-[10px] font-bold uppercase tracking-widest text-zinc-950 group-hover:gap-3 transition-all duration-100">
                    Read <ArrowRight size={11} strokeWidth={3} />
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>

      </div>

      <footer className="py-10 px-6 bg-zinc-50 border-t border-zinc-200">
        <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-[10px] font-bold text-zinc-300 uppercase tracking-widest">
            EA is a trademark of Electronic Arts. This site is a parody. &nbsp;·&nbsp;{' '}
            <a href="https://itorzo.com" target="_blank" rel="noopener noreferrer" className="hover:text-zinc-500 transition-colors">An Itorzo product</a>
          </p>
          <div className="flex items-center gap-5">
            <a href="/blog" className="text-[10px] font-bold text-zinc-400 uppercase tracking-widest hover:text-zinc-950 transition-colors">Blog</a>
            <a href="/privacy" className="text-[10px] font-bold text-zinc-400 uppercase tracking-widest hover:text-zinc-950 transition-colors">Privacy</a>
            <a href="/terms" className="text-[10px] font-bold text-zinc-400 uppercase tracking-widest hover:text-zinc-950 transition-colors">Terms</a>
            <a href="/contact" className="text-[10px] font-bold text-zinc-400 uppercase tracking-widest hover:text-zinc-950 transition-colors">Contact</a>
          </div>
        </div>
      </footer>
    </div>
  );
}
